// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3716) return "static/chunks/3716-82478885770f8ef4.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1663 ? "3d1b2d1e" : chunkId) + "." + {"659":"6bf7a39b2a9f3436","1663":"c5e9f317becf93c2","5321":"5a5c17ba381c6135","6935":"773f003ffad55fa9","9003":"0b45770d2ecd1b2f"}[chunkId] + ".js";
};